import React from 'react';
import styles from './ErrorBoundry.less';
import { isRenderedOnServer } from '../../../utils/envUtils';
import errorLogger from '../../../utils/errorLogger';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(err) {
    if (isRenderedOnServer()) {
      return;
    }

    this.setState({ hasError: true });
    try {
      errorLogger.log(err || new Error('Unknow error'));
    } catch (ex) {
      window.console && window.console.error && window.console.error(ex);
    }
  }

  render() {
    if (this.state.hasError) {
      /* TODO define proper error text */
      return (
        <h4 className={styles.errorHeadline}>
          Tut uns leid da ist etwas schief gelaufen. Diesen Inhalt können wir dir gerade leider nicht zeigen.
        </h4>
      );
    }
    return this.props.children;
  }
}
